<template>
  <node-view-wrapper class="embed-block-data">
    <v-row v-if="!node.attrs.path">
      <v-col>
        <v-card min-width="300px" max-width="400px">
          <v-form ref="form">
            <v-card-title> Select block data </v-card-title>
            <v-card-subtitle
              >URL
              <v-select :items="activeSpacePaths" v-model="path"></v-select>
            </v-card-subtitle>
            <v-card-subtitle
              >Selection (htmltags)
              <v-text-field v-model="selection" />
            </v-card-subtitle>
            <v-card-subtitle
              >Children (regex)
              <v-text-field v-model="children" />
            </v-card-subtitle>
            <v-card-subtitle>
              <v-checkbox
                @change="viewJSON"
                label="DataJSON?"
                v-model="dataJSONBool"
              />
            </v-card-subtitle>
            <v-card-actions
              ><v-btn @click="setData" color="primary">OK</v-btn
              ><v-spacer /><v-btn @click="showPreview" color="primary"
                >Preview</v-btn
              ></v-card-actions
            >
          </v-form>
        </v-card>
      </v-col>
      <v-col v-if="previewEnabled">
        <v-card>
          <pre>{{ previewContent }}</pre>
        </v-card>
      </v-col>
    </v-row>

    <pre v-else> {{ embeddedContent }}</pre>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from "@tiptap/vue-2";
import { mapGetters } from "vuex";
import store from "@/store";

import axios from "axios";

export default {
  data() {
    return {
      show: true,
      embeddedContent: null,
      path: null,
      selection: null,
      children: null,
      previewEnabled: false,
      previewContent: null,
      dataJSONBool: false,
      dataJSON: null
    };
  },
  components: {
    NodeViewWrapper
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    updateAttributes: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(["activeSpacePaths"])
  },
  mounted() {
    if (this.node.attrs.path) {
      this.path = this.node.attrs.path;
      this.selection = this.node.attrs.selection;
      this.children = this.node.attrs.children;
      this.loadData();
    }
  },
  methods: {
    async loadData(preview) {
      const { data } = await axios(`/api/data/${this.path}`, {
        headers: { jwt: store.state.userToken },
        params: { selection: this.selection, children: this.children }
      });

      if (preview) {
        this.previewContent = `${JSON.stringify(
          data.simplifiedTipTapJSON,
          null,
          2
        )}`;
      } else {
        this.updateAttributes({
          path: this.path,
          selection: this.selection,
          children: this.children
        });
        this.embeddedContent = `${JSON.stringify(
          data.simplifiedTipTapJSON,
          null,
          2
        )}`;
      }
      this.dataJSON = data;
      this.dataJSONBool = false;
    },
    showPreview() {
      this.previewEnabled = true;
      this.loadData(true);
    },
    setData() {
      this.loadData(false);
    },
    viewJSON() {
      if (this.dataJSONBool) {
        this.previewContent = `${JSON.stringify(
          this.dataJSON.dataJSON,
          null,
          2
        )}`;
      } else {
        this.previewContent = `${JSON.stringify(
          this.dataJSON.simplifiedTipTapJSON,
          null,
          2
        )}`;
      }
    }
  }
};
</script>
<style scoped>
.preClass {
  background: #fff;
  color: #000;
}
</style>
